import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { SdvorSharedCmsComponents } from '../cms-components.enum';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        AccordionModule: {
          module: () => import('./accordion-lazy.module').then((m) => m.AccordionLazyModule),
          cmsComponents: [
            SdvorSharedCmsComponents.RosaCMSAccordionItemComponent,
            SdvorSharedCmsComponents.RosaCMSAccordionSlotComponent,
          ],
        },
      },
    }),
  ],
})
export class AccordionModule {}
